<template>
    <div class="toggle-switch">
        <input
            type="checkbox"
            id="check"
            class="tgl tgl-light"
            :disabled="true"
            v-model="localValue"
            @change="emitChange"
            :checked="value"
        />
        <label class="tgl-btn" for="check" @click="toggleClick" v-if="clickable"></label>
        <label class="tgl-btn" for="check" v-else></label>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    value: {
        type: Boolean,
        required: true
    },
    clickable: {
        type: Boolean,
        required: false
    }
});

const emit = defineEmits(['update:modelValue', 'change']);
const localValue = ref(props.value);

watch(() => props.value, (newValue) => {
    localValue.value = newValue;
});

function toggleClick() {
    localValue.value = !localValue.value;
    emitChange();
}

function emitChange() {
    emit('update:modelValue', localValue.value);
    emit('change', localValue.value);
}
</script>

<style lang="scss">
.toggle-switch {
    display: inline-block;
    vertical-align: middle;
}

.tgl {
    display: none;

    // add default box-sizing for this scope
    &,
    &:after,
      &:before,
    & *,
      & *:after,
      & *:before,
    & + .tgl-btn {
        box-sizing: border-box;
        &::selection {
            background: none;
        }
    }

    + .tgl-btn {
        outline: 0;
        display: block;
        width: 3em;
        height: 1.5em;
        position: relative;
        cursor: pointer;
        user-select: none;

        &:after,
        &:before {
            position: relative;
            display: block;
            content: "";
            width: 50%;
            height: 100%;
        }

        &:after {
            left: 0;
        }

        &:before {
            display: none;
        }
    }

    &:checked + .tgl-btn:after {
        left: 50%;
    }
}

// themes
.tgl-light {
    + .tgl-btn {
        background: #ccc;
        border-radius: 1.2em;
        padding: 2px;
        transition: all .4s ease;

        &:after {
            border-radius: 50%;
            background: #fff;
            transition: all .2s ease;
        }
    }

    &:checked + .tgl-btn {
        background: #0064B6;
    }
}
</style>
